{#if mainObj.transactionHistories.length > 0}

	{#if hashArr.length > 0}
		
		<h2>
			<a rel="noopener" target="_blank" href="https://github.com/hundredrabbits/Orca">
				♯ORCΛ
			</a>
		</h2>
		<p><small><sub>if you click , can copy to clipboard .</sub></small></p>
		
		<div class="fullhash-wrapper--orca">
			{#each hashArr as hash,i} 

				{#if i === 0}
					<div class="orca-bang--total" style="width: 100%; height: 50vh;">
						<textarea style="height: 100%;" onClick="this.select();document.execCommand('Copy');">{makeTotalBangsOnModuloOfFrame(hashArr)}</textarea>
					</div>
				{/if}

				<div class="orca-bang--each">
					<textarea onClick="this.select();document.execCommand('Copy');">{makeBangsOnModuloOfFrame(hash)}</textarea>
					<p>
						<span>
							<!-- 表示上の問題だから半角スペースx2を表示する -->
							{@html makeBangsOnModuloOfFrame(hash).replace(/\r?\n/g, '<br>').replace('\u0020','\u00a0\u00a0')}
						</span>
					</p>
				</div>

				
			{/each}
		</div>

	{:else}

		<button on:click={fixForOrcaFromTransactionHistories(mainObj.transactionHistories)}> play ORCΛ (make Bang snipet) 🎹 </button>

	{/if}

{/if}

<script>
	import { afterUpdate } from "svelte";	

	let hashArr = [];

	// 渡されてきたやつら
	export let mainObj;

	// DOM更新後
	afterUpdate(()=>{
	});


	// --------------
	// ORCA snipet 系 (切り出し？)
	// --------------
	function fixForOrcaFromTransactionHistories(transactionHistories){
		const tmp = [];
		transactionHistories.forEach(history=>{
			Object.entries(history).forEach(arr=>{
				if(["from","to","hash","blockHash"].includes(arr[0])){
					tmp.push(arr[1]);
				}
			});
		});		
		hashArr = tmp;
	}
	function makeBangsOnModuloOfFrame(targetStr){

		const strUpper = targetStr.toUpperCase().slice(2); // 0x 削除

		const nums      = [];
		const alphabets = [];

		strUpper.split("").forEach(i=>{
			// アルファベットと数値へ分ける
			i.match(/[A-Z]/) ? alphabets.push(i) : nums.push(i);
		});

		const obj = {
			rhythm: nums[0], 
			channel: strUpper[0],
			octave:  nums[1],
			note: alphabets[0],
			velocity: nums[2],
			length: nums[3]    
		}

		const orca = "D"+obj.rhythm+"\n :"+obj.channel+obj.octave+obj.note+obj.velocity+obj.length;
		// console.log(orca);
		return orca; // 文字列返す一旦
	}
	// 結合版の作成用
	function makeTotalBangsOnModuloOfFrame(strArr){
		const arr = strArr.map(str=>{
			return makeBangsOnModuloOfFrame(str);
		});
		return arr.join('\n');
	}
</script>

<style lang="scss">
	.fullhash-wrapper--orca {
		margin-top: 1rem;
	// 	margin: 1rem -1.1em 0;
	// 	padding: .5rem;
	// 	background-color: #fff;
	// 	overflow-x: scroll;
	// 	pointer-events: none;
		display: flex;
		flex-wrap: wrap;

		& > .orca-bang--each {
			position: relative;
			height: 100%;

			& > textarea {
				background: transparent;
				color: transparent;
				cursor: copy;
				width: 100px;
			}

			& > p {
				position: absolute;
				top: 6px;
				left: 0;
				right: 0;
				width: fit-content;
				height: calc(100% - 6px);
				margin: 0 auto;
				text-align: left;
				z-index: -1;
				
				& > span {
					color: #fff;
					background-color: #333;
				}
			}
		}
	}
</style>
